import React, { useEffect, useState } from 'react';
import { withTabBackButton, WithTabBackButtonStateProps } from 'components/tab';
import { IStyle } from 'Styles';
import CustomCheckBox from 'components/input/customCheckBox';
import { EHarvestingView } from '../constants';
import RMButton from 'components/customComponents/Controls/RMButton';
import { useCrystalStates } from '../Crystal/hooks';
import { FmlxButton } from 'fmlx-common-ui';

export interface AgentDTO {
  id: number;
  label: string;
  checked: boolean;
}
interface SelectAgentsProps extends WithTabBackButtonStateProps {
  agentsList?: AgentDTO[];
  handleBackToPreviousScreen?: (contentView: EHarvestingView) => () => void;
  onSelectAgent: (id: number) => () => void;
  applyChanges: () => void;
}

const SelectAgents = (props: SelectAgentsProps) => {
  const {
    agentsList,
    handleBackToPreviousScreen,
    setHandleOnTabBackPress,
    onSelectAgent,
    applyChanges,
  } = props;
  const [searchValue, setSearchValue] = useState('');
  const { harvestingContentView } = useCrystalStates();
  useEffect(() => {
    if (
      handleBackToPreviousScreen &&
      (harvestingContentView === EHarvestingView.SELECTCRYO ||
        harvestingContentView === EHarvestingView.SELECTSOAKING)
    ) {
      setHandleOnTabBackPress(() =>
        handleBackToPreviousScreen(EHarvestingView.HARVESTING),
      );
    }
  }, [setHandleOnTabBackPress, harvestingContentView]);

  return (
    <>
      <div id={`exp-selectagents-listdiv`} style={styles.listDiv}>
        <div id={`exp-selectagents-searchdiv`} className="flex flex-space-between" style={styles.searchDiv}>
          <input id={`exp-selectagents-search-input`}
            type="text"
            placeholder={'Search here...'}
            style={styles.searchBar}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
        </div>
        <div id={`exp-selectagents-stocks`} className="stocks-container">
          {agentsList
            ?.filter((agent) =>
              agent.label.toLowerCase().includes(searchValue.toLowerCase()),
            )
            .map((agent) => (
              <div
                id={`exp-selectagents-agentslist`}
                key={`agent_${agent.id}`}
                {...(agent.checked && { className: 'bg-[#85BAFF]' })}
              >
                <CustomCheckBox id={`exp-selectagents-checkbox`}
                  label={agent.label}
                  onChange={() => onSelectAgent(agent.id)}
                  checked={agent.checked}
                  labelStyle={styles.labelStyle}
                />
              </div>
            ))}
        </div>
      </div>
      <div id={`exp-selectagents-actions`} className="absolute bottom-6 right-0 mr-4">
        <RMButton
          id={`exp-selectagents-apply-button`}
          customStyle={styles.save}
          onClick={applyChanges}
          label="Apply"
          type={FmlxButton.Type.POSITIVE}
        ></RMButton>
      </div>
    </>
  );
};
export default withTabBackButton(SelectAgents);
const styles: IStyle = {
  labelStyle: {
    fontSize: 15,
    marginLeft: '0.5rem',
  },
  save: {
    backgroundColor: '#4AAE53',
    width: '5.5rem',
  },
  searchDiv: {
    padding: '1.45% 4.36%',
    position: 'sticky',
  },
  searchBar: {
    width: '100%',
    padding: '1.25% 2.34%',
    height: '2.125%',
  },
  listDiv: {
    height: '72vh',
    overflow: 'scroll',
  },
};
